// src/services/apiClient.js
import axios from "axios";
import { store } from "../store";
import { logout } from "../store/authSlice";
import normalizeApiError from "./extractApiError";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "/api",
  withCredentials: true, // حسب الحاجة
});

// طلبات: إرفاق التوكن + Accept-Language من i18n لو أردت
api.interceptors.request.use((config) => {
  try {
    const state = store.getState();
    const token = state.auth?.token || localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {}
  // يمكنك إضافة لغة الواجهة:
  // const lang = localStorage.getItem('i18nextLng') || 'ar';
  // config.headers['Accept-Language'] = lang;
  return config;
});

// ردود: لو 401 نسوي logout
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const normalized = normalizeApiError(error);
    if (normalized.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(normalized);
  }
);
export const apiClient = api;
export default api;
